import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { CONNECTED_SWIPER_INFO } from 'assets/json/scooterInfo.js'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 스마트스쿠터 화면에서 상단의 스쿠터 타입 영역의 swiper
 */
function ScooterEvC1SwiperFour() {
    const settings = {
        className: 'evc1_connected_swiper',
        direction: 'horizontal',
        //slidesPerView: 'auto', // 한 화면에 보이는 슬라이드 수
        //spaceBetween: 0, // px 단위 간격
        loop: false,
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.evc1_eight_swiper_btn.next', // 다음 버튼 클래스명
            prevEl: '.evc1_eight_swiper_btn.prev', // 이전 버튼 클래스명
        },
        breakpoints: {
            376: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            821: {
                slidesPerView: 'auto',
                spaceBetween: 64,
            },
        },
    }

    return (
        <Swiper {...settings}>
            <div className="swiper-wrapper">
                {CONNECTED_SWIPER_INFO.map((val, i) => (
                    <SwiperSlide className="swiper-slide" key={'scooter-viva-img-desc-swiper-slide-' + i}>
                        <img className="img-box pc" src={val.imgUrlPc} alt="" />
                        <img className="img-box pad" src={val.imgUrlPad} alt="" />
                        <img className="img-box mobile" src={val.imgUrlMo} alt="" />
                        <div className="text-box">
                            <div className="number_wrap">
                                <div className="number1">{val.numbering}</div>
                                <div className="number1_under"></div>
                            </div>
                            <div className="t1" dangerouslySetInnerHTML={{ __html: val.title }}></div>
                        </div>
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    )
}

export default ScooterEvC1SwiperFour
